import {
  AccountType,
  BankAccount,
  BusinessType,
  DeliveryTimeframe,
  TaxNumberType
} from 'generated/graphql'
import {
  EntityMccs,
  Individuals,
  MerchantApplicationData
} from 'pages/Onboarding'
import { toNumericString } from './transform-utils'

export const mapMerchantApplicationToForm = (
  merchantApplication: MerchantApplicationData,
  bankAccounts?: BankAccount[],
  individuals?: Individuals,
  entityMccs?: EntityMccs | null
) => {
  const { businessStructureDetails, taxInfo } = merchantApplication

  return {
    ...merchantApplication,
    mccCodes: entityMccs ?? [],
    businessDetails: {
      ...merchantApplication.businessDetails
    },
    businessActivity: {
      ...merchantApplication.businessActivity,
      ecommerceBasisPoints: toNumericString(
        merchantApplication.businessActivity?.ecommerceBasisPoints
      ),
      manuallyKeyedCnpMotoBasisPoints: toNumericString(
        merchantApplication.businessActivity?.manuallyKeyedCnpMotoBasisPoints
      ),
      manuallyKeyedCpImprintBasisPoints: toNumericString(
        merchantApplication.businessActivity?.manuallyKeyedCpImprintBasisPoints
      ),
      cardPresentBasisPoints: toNumericString(
        merchantApplication.businessActivity?.cardPresentBasisPoints
      ),
      businessToBusinessBasisPoints: toNumericString(
        merchantApplication.businessActivity?.businessToBusinessBasisPoints
      ),
      monthlyCardVolumeAmount: toNumericString(
        merchantApplication.businessActivity?.monthlyCardVolumeAmount
      ),
      maximumMonthlyCardVolumeAmount: toNumericString(
        merchantApplication.businessActivity?.maximumMonthlyCardVolumeAmount
      ),
      averageTransactionAmount: toNumericString(
        merchantApplication.businessActivity?.averageTransactionAmount
      ),
      maximumTransactionAmount: toNumericString(
        merchantApplication.businessActivity?.maximumTransactionAmount
      )
    },
    businessStructureDetails: {
      ...businessStructureDetails,
      registeredBusinessAddress: {
        ...businessStructureDetails?.registeredBusinessAddress,
        countryAlpha2:
          businessStructureDetails?.registeredBusinessAddress?.country
            ?.alpha2 ?? null
      },
      physicalBusinessAddress: {
        ...businessStructureDetails?.physicalBusinessAddress,
        countryAlpha2:
          businessStructureDetails?.physicalBusinessAddress?.country?.alpha2 ??
          null
      },
      dateOfIncorporation: businessStructureDetails?.dateOfIncorporation
        ? Number(businessStructureDetails.dateOfIncorporation)
        : null,
      businessType:
        businessStructureDetails?.businessType ?? BusinessType.Internet,
      sameAsRegisteredAddress:
        businessStructureDetails?.physicalAddrSameAsRegistered ?? false
    },
    taxInfo: {
      ...taxInfo,
      taxpayerIdType: taxInfo?.taxpayerIdType ?? TaxNumberType.Ein,
      exemptPayee: taxInfo?.exemptPayee ?? false,
      taxExempt501c: taxInfo?.taxExempt501c ?? false,
      electronicTaxDocumentConsent:
        taxInfo?.electronicTaxDocumentConsent ?? false,
      sameAsRegisteredAddress:
        taxInfo?.taxAddressSameAsRegisteredBusinessAddress ?? false
    },
    businessProcessingInfo: {
      ...merchantApplication.businessProcessingInfo,
      hasExistingPaycomMerchant:
        merchantApplication.businessProcessingInfo?.hasExistingPaycomMerchant ??
        false,
      wantsAmexMarketingMaterials:
        merchantApplication.businessProcessingInfo
          ?.wantsAmexMarketingMaterials ?? false
    },
    fulfillmentDetails: {
      ...merchantApplication.fulfillmentDetails,
      deliveryTimeframe:
        merchantApplication.fulfillmentDetails?.deliveryTimeframe ??
        DeliveryTimeframe.Immediate
    },
    individuals,
    bankAccounts: bankAccounts?.map(account => ({
      ...account,
      accountType: account.accountType ?? AccountType.Checking
    }))
  }
}
